module.exports = __webpack_public_path__ + "static/media/casa-reina-2bed.acbbf47a.jpg";